import { render } from "./RequirePasswordChangeModal.vue?vue&type=template&id=24df698c"
import script from "./RequirePasswordChangeModal.vue?vue&type=script&lang=js"
export * from "./RequirePasswordChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__